/* eslint-disable no-useless-escape */
/* 

  Regex

*/

export const REGEX_PASSWORD =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[\*\^\°\!\“\§\$\%\&\/\(\)\=\?\´\`\+\*\#\’\,\;\.\:\-\_]).{12,}/g;

// zod email will not accept a + sign. So we need to use a regex to validate the email
export const REGEX_USERS_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
